import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import {
  Col,
  Row,
  Modal,
  Form,
  Spin,
  Button,
  Input,
} from 'antd';
import {
  ArrowLeftOutlined,
  SaveOutlined,
} from '@ant-design/icons';
import FormSubmitControls from 'components/FormSubmitCustomControls';
import Select from 'components/Select';
import { onError } from 'utils/handlers';
import { postObtenerReporte } from 'api/reporteador';
import { getUnidadDeRecaudacion } from 'api/configuracion/unidadesDeRecaudacion';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import Previewer from 'components/Previewer';
import { getMotocicleta } from 'api/recaudacion/motocicletas';

export const imprimirTarjetaDeCirculacionMoto = async (
  setLoading = () => { },
  tramite,
  selectedRowKey,
  callback = () => { },
) => {
  setLoading(true);
  const match = await getMotocicleta(selectedRowKey);
  const unidadDeRecaudacion = await getUnidadDeRecaudacion(match.unidad_de_recaudacion || 1);
  const fechaDeExpedicion = new Moment().format(DATE_FRONTEND_FORMAT.replace('\\/', '-'));
  const values = {
    ID: match.es_propietario_ciudadano ? 46 : 47,
    Parametros: [
      {
        Nombre: 'clave',
        TipoParametro: 'Texto',
        Valor: match.clave,
      },
      {
        Nombre: 'fecha_expedicion',
        TipoParametro: 'Texto',
        Valor: fechaDeExpedicion,
      },
      {
        Nombre: 'clave_recaudadora',
        TipoParametro: 'Texto',
        Valor: unidadDeRecaudacion.clave,
      },
      {
        Nombre: 'marca',
        TipoParametro: 'Texto',
        Valor: tramite.marca,
      },
      {
        Nombre: 'tramite',
        TipoParametro: 'Texto',
        Valor: tramite.tramite,
      },
      {
        Nombre: 'anio',
        TipoParametro: 'Texto',
        Valor: tramite.anio,
      },
    ],
  };
  const file = await postObtenerReporte(values);
  if (file && typeof callback === 'function') {
    callback(file);
  }
  setLoading(false);
  return file;
};

const ModalTramiteMotocicletas = ({
  visible,
  setVisible,
  selectedRowKey,
  tipoDeTramite,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [base64, setBase64] = useState();
  const [visiblePreview, setVisiblePreview] = useState(false);

  const onCancel = () => {
    form.resetFields();
    setVisible(false);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      const values = form.getFieldsValue();
      await imprimirTarjetaDeCirculacionMoto(
        setLoading,
        values,
        selectedRowKey,
        (success) => {
          setBase64(success);
          setVisiblePreview(true);
        },
      );
      setLoading(false);
    } catch (error) {
      onError(error, setLoading);
    }
  };

  const saveControl = {
    text: 'Guardar',
    icon: <SaveOutlined />,
    onClick: () => onFinish(),
  };

  const backControl = {
    text: 'Regresar',
    icon: <ArrowLeftOutlined />,
    onClick: () => onCancel(),
  };

  const getControls = () => [backControl, saveControl];

  const options = [
    { descripcion: 'Alta' },
    { descripcion: 'Compraventa' },
    { descripcion: 'Cambio de Propietario' },
    { descripcion: 'Refrendo' },
    { descripcion: 'Cambio de Motor' },
  ];

  const rules = { required: [{ required: true }] };

  return (
    <Modal
      footer={null}
      closable={false}
      visible={visible}
      loading={loading}
      title={(
        <FormSubmitControls
          loading={loading}
          label="Datos Necesarios para la Tarjeta"
          controls={getControls()}
        />
      )}
    >
      <Spin tip="Cargando..." spinning={loading}>
        <Row>
          <Col span={24}>
            <Form
              form={form}
              layout="vertical"
              name="tarjeta"
              onFinish={() => onFinish()}
              initialValues={{ tramite: tipoDeTramite }}
            >
              <Col span={24}>
                <Form.Item
                  name="marca"
                  label="Marca y Submarca"
                  hasFeedback
                  rules={rules.required}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="tramite"
                  label="Tipo de Tramite"
                  hasFeedback
                  rules={rules.required}
                >
                  <Select
                    dataSource={options}
                    valueProp="descripcion"
                    disabled={!!tipoDeTramite}
                  />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Spin>
      <Previewer
        visible={visiblePreview}
        setVisible={setVisiblePreview}
        base64={base64}
      />
    </Modal>
  );
};

ModalTramiteMotocicletas.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  selectedRowKey: PropTypes.number,
  tipoDeTramite: PropTypes.string,
};

ModalTramiteMotocicletas.defaultProps = {
  selectedRowKey: null,
  tipoDeTramite: null,
};
export default ModalTramiteMotocicletas;
